<template>
<!-- Builds links to search on the internet -->
  <div id="mainContainer">
    <help-popup v-bind:show="showHelp" v-bind:text="pageText.help.text[selectedLang]" v-bind:title="pageText.help.title[selectedLang]" v-bind:selectedLang="selectedLang"></help-popup>
     <!-- Display title with an help button -->
    <div id="objectTitleContainer">
      <div id="helpButtonSizer">
      </div>
      <div id="objectTitleSizer">
        <h1>{{pageText.title[selectedLang]}}</h1>
      </div>
      <div id="helpButtonSizer" v-on:click="triggerHelp(true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
        </svg>
      </div>
    </div>
    <!-- Where user type his stuff -->
    <div id="formContainer">
      <label>{{pageText.form.label[selectedLang]}}</label>
      <div id="textAreaContainer">
        <textarea v-model="userInput"/>
      </div>
      <div id="formButton">
        <button class="btn btn-primary" v-on:click="redirectToCurrentPage()">{{pageText.form.button[selectedLang]}}</button>
      </div>
    </div>
    <!-- Where answer is shown -->
    <div id="answerContainer" v-if="showAnswer">
      <div id="searchHeader">
        <h2>{{pageText.answer.header[selectedLang]}}"{{searchReminder}}"</h2>
      </div>
      <div id="FlexContainer">
        <div id="googleFieldsetContainer">
          <div class="card" id="googleCard">
            <div class="card-img" id="googleImg">
              <img src="../assets/google-log.png" class="cardImg" alt="...">
            </div>
            <div class="card-body">
              <h5 class="card-title">Google</h5>
              <div id="googleContent">
              <div class="googleItem" v-for="item in explorer.google" v-bind:key="item">
                <img class="flag" src="../assets/uk-flag.png" v-if="item.flag == 'uk'"/>
                <img class="flag" src="../assets/usa.png" v-if="item.flag == 'usa'"/>
                <a v-bind:href="buildUrl(item)">{{item.name}}</a>
              </div>
            </div>
            </div>
          </div>
        </div>

        <!-- <div id="newspapersFieldsetContainer">
          <div class="card" id="newspapersCard">
            <div class="card-img" id="newspaperImg">
              <img src="../assets/newspapers.jpg" class="cardImg" alt="...">
            </div>
            <div class="card-body">
              <h5 class="card-title">{{pageText.answer.newspapers[selectedLang]}}</h5>
              <div id="newspapersContent">
                <div class="newspapersItem" v-for="item in explorer.newspapers" v-bind:key="item">
                  <img class="flag" src="../assets/uk-flag.png" v-if="item.flag == 'uk'"/>
                  <img class="flag" src="../assets/usa.png" v-if="item.flag == 'usa'"/>
                  <a v-bind:href="buildUrl(item)">{{item.name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="universitiesFieldsetContainer">
          <div class="card" id="newspapersCard">
            <div class="card-img" id="universitiesImg">
              <img src="../assets/UCL.jpg" class="cardImg" alt="...">
            </div>
            <div class="card-body">
              <h5 class="card-title">{{pageText.answer.universities[selectedLang]}}</h5>
              <div id="universitiesContent">
              <div class="universitiesItem" v-for="item in explorer.universities" v-bind:key="item">
                <img class="flag" src="../assets/uk-flag.png" v-if="item.flag == 'uk'"/>
                <img class="flag" src="../assets/usa.png" v-if="item.flag == 'usa'"/>
                <a v-bind:href="buildUrl(item)">{{item.name}}</a>
              </div>
            </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import HelpPopup from './HelpPopup.vue'

export default {
  name: 'WebExplorer',
  components : {
    HelpPopup
  },
  props : {
    selectedLang : String
  },
  methods : {
    /**
     * When user launch a search
     */
    handleInput () {
      this.termsList = this.userInput.split(";")
      this.showAnswer = true;
      this.searchReminder = this.userInput;
      this.userInput = "";
    },
    /**
     * Based on the representation of a website, build an url
     * 
     * @param item : The representation of a website
     * @requires item must be a dictionary like {
              name : 'The name the link will show',
              baseUrl : 'The part or url before keywords',
              separator : 'chars between each keyword',
              tailUrl : 'The part of url after keywords'
            }
     */

    /**
     * Reload current page with different parameters
     */
    redirectToCurrentPage(){
      this.$router.push({name : 'WebExplorer', params : {
          word : this.userInput
        }});
      this.handleInput();
    },

    buildUrl(item){
      let baseUrl = item.baseUrl;
      for (const searchTerm in this.termsList) {
        baseUrl += this.termsList[searchTerm] + item.separator;
      }
      return baseUrl.slice(0, - item.separator.length) + item.tailUrl
    },
    /**
     * Set showHelp to `show`
     * 
     * @param show (boolean) : Value to be set for showHelp
     */
    triggerHelp(show){
      this.showHelp = show;
    }
  },
  data (){
    return {
      // Page static text available
      // in french, english and dutch
      pageText : {
        title : {
          en : 'Explore the web',
          fr : 'Explorer le web',
          nl : 'Doorzoek het web'
        },
        form : {
          label : {
            en : "Enter the English terms you wish to search for, separated by ';'",
            fr : "Entrez les termes anglais que vous souhaitez rechercher, séparés par des ';'",
            nl : "Voer de Engelse termen in waarop u wilt zoeken, gescheiden door ';'"
          },
          button : {
            en : 'Explore',
            fr : 'Explorer',
            nl : 'Doorzoek'
          }
        },
        answer : {
          header : {
            en : 'Results for ',
            fr : 'Résultats pour',
            nl : 'Resultaten voor '
          },
          newspapers : {
            en : 'Newspapers',
            fr : 'Journaux',
            nl : 'Kranten'
          },
          universities : {
            en : 'Universities',
            fr : 'Universités',
            nl : 'Universiteiten'
          }
        },
        help : {
          title : {
            fr : "Utilisation de l'outil d'exploration web",
            en : "Using the web-browsing tool",
            nl : "Gebruik van het web-browsing hulpmiddel"
          },
          text : {
            fr : "Entrez une liste de termes que vous souhaitez rechercher sur le web anglophone, séparés par des ';'. Les guillemets sont inutiles, il vous suffit d'entrer une expression sans séparateurs (ex : 'PhD  committee;' au lieu de 'Phd; Committee;') pour effectuer une recherche incluant un groupe de mots.",
            en : "Enter a list of terms you wish to search for on the English web, separated by ';'. You don't need inverted commas, just enter a phrase without separators (e.g. 'PhD committee;' instead of 'Phd; Committee;') to search for a group of words.",
            nl : "Voer een lijst van termen in die u wilt zoeken op het Engelse web, gescheiden door ';'. U hebt geen aanhalingstekens nodig, voer gewoon een zin in zonder scheidingstekens (bv. 'PhD committee;' in plaats van 'Phd; Committee;') om naar een groep woorden te zoeken."
          }
        }
      },
      showAnswer : false,
      showHelp : false,
      userInput : '',
      termsList : [],
      searchReminder : "",
      explorer : {
        google : [
          {
            flag : 'uk',
            name : 'Sites ac.uk',
            baseUrl : 'https://www.google.com/search?hl=en&q="',
            separator : '"+"',
            tailUrl : '"+site:ac.uk&btnG=Google+Search&meta='
          },
          {
            flag : 'usa',
            name : 'Sites .edu',
            baseUrl : 'https://www.google.com/search?hl=en&q="',
            separator : '"+"',
            tailUrl : '"+site:edu&btnG=Google+Search&meta='
          }
        ],
        newspapers : [
          {
            flag : 'uk',
            name : 'Guardian education',
            baseUrl : 'https://www.google.com/search?hl=en&q="',
            separator : '"+"',
            tailUrl : '"+site:theguardian.com/uk&btnG=Google+Search&meta='
          }
        ],
        universities : [
          {
            flag : 'uk',
            name : 'Cambridge University',
            baseUrl : 'https://search.cam.ac.uk/search.html?collection=cam-meta&query="',
            separator : '"+"',
            tailUrl : '"'
          },
          {
            flag : 'uk',
            name : 'Oxford University',
            baseUrl : 'https://www.ox.ac.uk/search?query="',
            separator : '" %2B "',
            tailUrl : '"'
          },
          {
            flag : 'uk',
            name : 'Manchester University',
            baseUrl : 'https://www.manchester.ac.uk/search/?q="',
            separator : '"+%2B+"',
            tailUrl : '"&site=University&client=MAN_aboutus_search'
          },
          {
            flag : 'uk',
            name : 'Leeds University',
            baseUrl : 'https://www.leeds.ac.uk/search?q="',
            separator : '"+%2B+"',
            tailUrl : '"&searchOption=searchSite'
          },
          {
            flag : 'uk',
            name : 'Birmingham University',
            baseUrl : 'https://www.birmingham.ac.uk/search?facet=all&term="',
            separator : '" %2B "',
            tailUrl : '"'
          }
        ]
      }
    }
  },
   // On load function
  activated : function () {
    // load lang from route param if given value is correct
    
    if (this.$route.params.word != undefined && this.$route.params.word != "") {
     this.userInput = this.$route.params.word;
     this.handleInput();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#mainContainer {
  width: 100%;
  height: 97%;
}

h1 {
  text-align: center;
  font-size: 2vw;
}

#formContainer {
  margin-right: auto;
  margin-left: auto;
  width: 80%;
  height: 25%;
  z-index: 1000;
}

#formContainer label {
  font-weight: bold;
  font-size: 0.8vw;
}

#textAreaContainer {
  width: 100%;
  height: 50%;
}

#formButton {
  width: 10%;
  height: 20%;
  margin: auto;
}

textarea {
  width: 95%;
  height: 80%;
}

#answerContainer {
  margin-top: 4%;
  width: 100%;
  height: 40%;
}

#FlexContainer{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}

#searchHeader{
  width: 100%;
  text-align: center;
}

#googleFieldsetContainer, #newspapersFieldsetContainer, #universitiesFieldsetContainer {
  width: 30%;
  height: 100%;
}

#universitiesContent {
  width: 100%;
  height: 80%;
  overflow: auto;
}

#answerContainer .flag {
  width: 10%;
  margin-right: 1%;
}

.card {
  width: 100%;
  height: 100%;
}

.card-body {
  width: 100%;
  height: 70%;
}

.card-img {
  margin-left: auto;
  margin-right: auto;
  height: 30%;
}

.cardImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#googleImg{
  width: 60%;
}

#newspaperImg {
  width: 100%;
}

.newspapersItem, .googleItem, .universitiesItem {
  margin-top: 2%;
}

@media screen and (max-width: 850px) {
  h1 {
    font-size: 8vw;
  }

  #mainContainer {
    display: flex;
    flex-direction: column;
    height: auto;
  }

  #formContainer label {
    font-size: 3vw;
  }

  #textAreaContainer {
    display : flex;
  }

  textarea {
    margin-left : auto;
    margin-right: auto;
  }

  #formButton {
    width: 40%;
    height: 15%;
  }
  

  #formContainer {
    width : 100%;
    height : 40vh;
    z-index: 1;
    text-align: center;
  }

  #FlexContainer {
    /* height: 300vh; */
    flex-direction: column;
    justify-content: flex-start;
    margin : auto;
  }

  #googleFieldsetContainer, #newspapersFieldsetContainer, #universitiesFieldsetContainer {
    width: 100%;
    height: 20%;
  }

  #googleImg{
    width: 100%;
  }
}

@media screen and (max-width: 850px) and (orientation : landscape){
  h1 {
    font-size: 5vw;
  }

  #formContainer label {
    font-size: 2vw;
  }


  #FlexContainer {
    /* height: 300vh; */
    flex-direction: row;
    justify-content: flex-start;
    margin : auto;
  }
}

</style>
